import React from 'react';
import { autoId, useReactModal } from '@workday/upc-common';
import Modal from 'react-modal';
import { ProfileNameModalContent } from './ProfileNameModalContent';
import { useTranslation } from 'react-i18next';
import { Hyperlink, Flex } from '@workday/canvas-kit-react';
import styles from './ProfileNameSettingsRow.module.scss';

interface ProfileNameSettingsRowProps {
    userInfo: {
        firstName: string;
        lastName: string;
    };
}

export function ProfileNameSettingsRow({ userInfo }: ProfileNameSettingsRowProps) {
    // TODO: Handle localization (preferably server side)
    const fullName = [userInfo.firstName, userInfo.lastName].filter(Boolean).join(' ');

    const { t } = useTranslation('account');

    const onEditClick = () => {
        nameChangeModal.open();
    };

    const onClose = () => {
        nameChangeModal.close();
    };

    const nameChangeModal = useReactModal({ modalProps: { onRequestClose: onClose } });
    const { modalProps } = nameChangeModal;

    return (
        <div className='settingsRow'>
            <h1 className='settingsRow__title'>{t('ProfileNameSettingsRow.rowName')}</h1>
            <div className='settingsRow__content'>
                <Flex flexDirection='row' justifyContent='space-between' alignItems='center'>
                    <p className={styles.text}>{fullName}</p>
                    <Hyperlink
                        className={styles.editButton}
                        as='button'
                        {...autoId('editButton')}
                        onClick={onEditClick}
                        type='button'>
                        {t('ProfileNameSettingsRow.editButton')}
                    </Hyperlink>
                </Flex>
                <Modal {...modalProps}>
                    <ProfileNameModalContent userInfo={userInfo} onClose={onClose} />
                </Modal>
            </div>
        </div>
    );
}
